import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ButtonColor } from '@freelancer/ui/button';
import { RoleApi } from 'api-typings/common/common';

@Component({
  selector: 'app-user-profile-switch-views',
  template: `
    <fl-button
      flTrackingLabel="SwitchedProfileView"
      [color]="ButtonColor.DEFAULT"
      (click)="toggleType()"
    >
      <ng-container [ngSwitch]="currentType">
        <ng-container
          *ngSwitchCase="RoleApi.FREELANCER"
          i18n="User Profile View Client Profile Button"
        >
          View Client Profile
        </ng-container>
        <ng-container
          *ngSwitchCase="RoleApi.EMPLOYER"
          i18n="User Profile View Freelancer Profile Button"
        >
          View Freelancer Profile
        </ng-container>
      </ng-container>
    </fl-button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./user-profile-switch-views.component.scss'],
})
export class UserProfileSwitchViewsComponent {
  ButtonColor = ButtonColor;
  RoleApi = RoleApi;

  @Input() currentType: RoleApi;
  @Output() typeChange = new EventEmitter<RoleApi>();

  toggleType() {
    this.currentType = this.getOpposite(this.currentType);
    this.typeChange.emit(this.currentType);
  }

  getOpposite(type: RoleApi) {
    return type === RoleApi.FREELANCER ? RoleApi.EMPLOYER : RoleApi.FREELANCER;
  }
}
